import {
  Holder,
  Pic,
  Overlay,
  Tip,
  TitleHolder,
  PicHolder,
  PicPivot
} from "./VisionariesSlide1.style"

export default function VisionariesSlide1() {
  return (
    <Holder>
      <PicPivot>
        <PicHolder>
          <Pic src="/assets/textures/gallery/coronation_square/img-1a.jpg" />
          <Overlay>
            <TitleHolder>
              Meet the
              <br />
              Architects
            </TitleHolder>
            <Tip>The Visionaries Behind Coronation Square</Tip>
          </Overlay>
        </PicHolder>
      </PicPivot>
    </Holder>
  )
}
